import { render, staticRenderFns } from "./RestorationPopUpDetails.vue?vue&type=template&id=8835ba92&scoped=true&"
import script from "./RestorationPopUpDetails.vue?vue&type=script&lang=js&"
export * from "./RestorationPopUpDetails.vue?vue&type=script&lang=js&"
import style0 from "./RestorationPopUpDetails.vue?vue&type=style&index=0&id=8835ba92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8835ba92",
  null
  
)

export default component.exports